<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_money"
        title="Verrechnungssätze"
        @save="saveFirmPresets">
        <b-row>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Gebühr Bereitstellung Hebebühne"
                property="feeLiftingPlatform"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Gebühr Fahrzeugverbringung"
                property="feeVehicleMovement"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Gebühr Probefahrt"
                property="feeTestDrive"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Gebühr Fahrzeugreinigung"
                property="feeVehicleCleaning"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Energiepauschale"
                property="feeEnergy"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Stundenverrechnungssatz Karo"
                property="feeVehicleBody"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Stundenverrechnungssatz Lack"
                property="feeVehicleLacquer"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Stundenverrechnungssatz Elektro Karo"
                property="feeVehicleBodyElectric"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Stundenverrechnungssatz Elektro Lack"
                property="feeVehicleLacquerElectric"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Stundenverrechnungssatz NFZ Karo"
                property="feeVehicleBodyCommercial"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Stundenverrechnungssatz NFZ Lack"
                property="feeVehicleLacquerCommercial"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Standkosten pro Tag"
                property="feeVehicleParkingPerDay"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                label="Entsorgungskosten / Lagerung"
                property="feeDisposal"
                type="currency"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-arrows="true"
                label="Entsorgungskosten Lackmaterial in %"
                property="feeDisposalVarnish"
                step="0.01"
                type="number"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-arrows="true"
                label="Lackmaterial in %"
                property="lacquerMaterial"
                step="0.01"
                type="number"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-arrows="true"
                label="UPE Aufschlag in %"
                property="surchargeListPrice"
                step="0.01"
                type="number"/>
            <csp-desktop-info-card-element
                class="col-3"
                :form-context="formContext"
                :hide-arrows="true"
                label="Klein-/Verbrauchsmat. Aufschlag in %"
                property="feeConsumables"
                step="0.01"
                type="number"/>
        </b-row>
        <b-row>
            <csp-desktop-info-card-element
                class="col-6"
                :form-context="formContext"
                label="Signatur Freitext"
                property="signatureText"
                type="autogrowtextarea"/>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmPresets',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            saveFirmPresets(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmPresets(this.firmId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
